import React, { useState } from 'react';
import { FiEye, FiEyeOff, FiSave } from 'react-icons/fi';

const DEFAULT_PORT = '587';

const SmtpConfigForm = ({ onSaveAndConnect, onCancel }) => {
  const [form, setForm] = useState({
    name: '',
    host: '',
    port: DEFAULT_PORT,
    senderName: '',
    senderEmail: '',
    username: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const set = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Required';
    if (!form.host.trim()) e.host = 'Required';
    if (!form.senderEmail.trim()) e.senderEmail = 'Required';
    return e;
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    onSaveAndConnect({ ...form, port: form.port || DEFAULT_PORT });
  };

  return (
    <div className="ec-smtp-form-panel">
      <div className="ec-smtp-form-header">
        <div>
          <div className="ec-smtp-form-title">New SMTP Configuration</div>
          <div className="ec-smtp-form-subtitle">
            Fill in your SMTP details. The configuration name helps you identify this account later.
          </div>
        </div>
        <button className="ec-smtp-cancel-btn" onClick={onCancel}>✕ Cancel</button>
      </div>

      <div className="ec-smtp-form-body">
        {/* Config name */}
        <div className="ec-smtp-field full">
          <label className="ec-smtp-label required">Configuration Name</label>
          <input
            className={`ec-smtp-input${errors.name ? ' error' : ''}`}
            placeholder='e.g. "Company SMTP", "SendGrid Marketing", "Support Mailbox"'
            value={form.name}
            onChange={set('name')}
          />
          {errors.name
            ? <span className="ec-smtp-error">{errors.name}</span>
            : <span className="ec-smtp-hint">Used to identify this SMTP config in the saved list. Choose a name that reflects its purpose.</span>
          }
        </div>

        {/* Server + Port */}
        <div className="ec-smtp-row">
          <div className="ec-smtp-field grow">
            <label className="ec-smtp-label required">SMTP Server</label>
            <input
              className={`ec-smtp-input${errors.host ? ' error' : ''}`}
              placeholder="smtp.example.com"
              value={form.host}
              onChange={set('host')}
            />
            {errors.host && <span className="ec-smtp-error">{errors.host}</span>}
          </div>
          <div className="ec-smtp-field port">
            <label className="ec-smtp-label">Port</label>
            <input
              className="ec-smtp-input"
              placeholder={DEFAULT_PORT}
              value={form.port}
              onChange={set('port')}
            />
          </div>
        </div>

        {/* Sender Name + Sender Email */}
        <div className="ec-smtp-row">
          <div className="ec-smtp-field grow">
            <label className="ec-smtp-label">Sender Name</label>
            <input
              className="ec-smtp-input"
              placeholder="John Doe"
              value={form.senderName}
              onChange={set('senderName')}
            />
          </div>
          <div className="ec-smtp-field grow">
            <label className="ec-smtp-label required">Sender Email</label>
            <input
              className={`ec-smtp-input${errors.senderEmail ? ' error' : ''}`}
              placeholder="you@example.com"
              value={form.senderEmail}
              onChange={set('senderEmail')}
            />
            {errors.senderEmail && <span className="ec-smtp-error">{errors.senderEmail}</span>}
          </div>
        </div>

        {/* Username */}
        <div className="ec-smtp-field full">
          <label className="ec-smtp-label">Username</label>
          <input
            className="ec-smtp-input"
            placeholder="your@email.com"
            value={form.username}
            onChange={set('username')}
          />
        </div>

        {/* Password */}
        <div className="ec-smtp-field full">
          <label className="ec-smtp-label">Password</label>
          <div className="ec-smtp-password-wrap">
            <input
              className="ec-smtp-input"
              type={showPassword ? 'text' : 'password'}
              placeholder="••••••••"
              value={form.password}
              onChange={set('password')}
            />
            <button
              className="ec-smtp-pw-toggle"
              type="button"
              onClick={() => setShowPassword((v) => !v)}
            >
              {showPassword ? <FiEyeOff size={15} /> : <FiEye size={15} />}
            </button>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="ec-smtp-form-actions">
        <button className="ec-smtp-save-btn" onClick={handleSubmit}>
          <FiSave size={14} /> Save & Connect
        </button>
      </div>
    </div>
  );
};

export default SmtpConfigForm;
